import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Education.css';
import AESLogo from '../../Assets/aeslogo.png';
import UMlogo from '../../Assets/umlogo.png';
import AOSRLogo from '../../Assets/aosrnhslogo.png';

const Education = () => {

  useEffect(() => {
    AOS.init();
  }, [])


  return (
    <section id='timeline'>
    <div className="timelineBackground">
    <div className='introEducation'>
      <span className='introtimeline'
        data-aos="fade-up"
        data-aos-offset="-400"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center">Educational Background</span>
      <p 
        data-aos="fade-up"
        data-aos-offset="-400"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease"
        data-aos-mirror="true"
        data-aos-once="false"
        data-aos-anchor-placement="top-center">My educational background shows my unwavering commitment to lifelong learning and personal development. It attests to my unwavering pursuit of information and skill development in order to achieve in my chosen field.</p>
    </div>
    <div className='timelineContainer'>
      <div className='timelineList left-container'>
        <img src={UMlogo} alt="UM Logo" className='um'
           data-aos="fade"
           data-aos-offset="-350"
           data-aos-delay="50"
           data-aos-duration="1500"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"/>
        <div className='grad'
          data-aos="fade-right"
          data-aos-offset="-300"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-center">
          <div className="schoolDetails">
          <h3>University of Mindanao Tagum College</h3>
          <h4>Bachelor of Science in Information Technology</h4>
          <small>S.Y. 2018-2023</small>
          <p className="paragraph">Arellano St., Tagum City</p>
          </div>
        </div>
        <span className='left-container-arrow'
          data-aos="fade-right"
          data-aos-offset="-300"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-center"></span>
      </div>
      <div className='timelineList right-container'>
        <img src={UMlogo} alt="UM Logo" 
           data-aos="fade"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1500"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"/>
        <div className='grad'
           data-aos="fade-left"
           data-aos-offset="-300"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
          <div className="schoolDetails">
          <h3>University of Mindanao Tagum College</h3>
          <h4>Senior High School</h4>
          <small>S.Y. 2016 - 2018</small>
          <p className="paragraph">Arellano St., Tagum City</p>
           </div>
        
        </div> 
         <span className='right-container-arrow'
           data-aos="fade-left"
           data-aos-offset="-350"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"></span>
      </div>
      <div className='timelineList left-container'>
        <img src={AOSRLogo} alt="AOSR Logo" 
           data-aos="fade"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1500"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"/>
        <div className='grad'
           data-aos="fade-right"
           data-aos-offset="-300"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
             <div className="schoolDetails">
          <h3>Atty. Orlando S. Rimando NHS</h3>
          <h4>Junior High School</h4>
          <small>S.Y. 2012 – 2016</small>
          <p className="paragraph">Binuangan, Maco, Davao de Oro</p>
               </div>
         
        </div>
        <span className='left-container-arrow'
          data-aos="fade-right"
          data-aos-offset="-400"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-mirror="true"
          data-aos-once="false"
          data-aos-anchor-placement="top-center"></span>
      </div>
      <div className='timelineList right-container'>
        <img src={AESLogo} alt="AES Logo" 
           data-aos="fade"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1500"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"/>
        <div className='grad'
           data-aos="fade-left"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">
            <div className="schoolDetails">
          <h3>Anislagan Elementary School</h3>
          <small>S.Y. 2006-2012</small>
          <p className="paragraph">Anislagan, Maco, Davao de Oro</p>
          </div>
        
        </div>
        <span className='right-container-arrow'
           data-aos="fade-left"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"></span>
      </div>
    </div>
    </div>
  </section>

  )
}

export default Education
